import { memo } from "react";
import Home from "./Home";

/**
 * Multi-design system removed. Always renders the single Home layout.
 * `previewDesignId` prop is accepted for backward compatibility but ignored.
 */
const HomepageRenderer = memo((_props: { previewDesignId?: number | null }) => {
  return (
    <div className="homepage">
      <Home />
    </div>
  );
});

HomepageRenderer.displayName = "HomepageRenderer";

export default HomepageRenderer;
